export default __webpack_public_path__ + "static/media/NavMapIcons-08.8157db30.png";